import Styles from '../../../1.manual/3.school/2.edit/styles.module.css';
import 'firebase/auth'
import React from 'react';
import { useState } from 'react';
import ErrorMessage from '../../../../package/error/index';
import { getFirestore } from 'firebase/firestore';
import { writeJobPostingBothStores } from '../../jobPostingRef';

type hashTagData = {
  isCompleted: boolean,
  tags1: string[],
  tags2: string[],
  tags3: string[],
};

type RecruitHashTag = {
  companyId: string;
  year: string;
  setChangeData: React.Dispatch<React.SetStateAction<boolean>>;
  hashTag: hashTagData;
  setHashTag: React.Dispatch<React.SetStateAction<hashTagData>>;
};

const RecruitHashTag: React.FC<RecruitHashTag> = ({ companyId, year, setChangeData, hashTag, setHashTag }) => {

  const [ errorMessage, setErrorMessage ] = useState('');
  const [ banner, setBanner ] = useState<boolean>(false);

  var 教育体制の特徴 = [
    'デビューまで2年以内',
    'SNS研修あり',
    '自社アカデミーあり',
    '動画研修制度あり',
    'セミナー参加費補助',
    'ウィッグ代補助',
    '奨学金返済サポートあり',
    '営業中の練習OK',
    '資格取得支援',
    '社内コンテストあり',
    '複数の教育体制から選択可',
    '複数のキャリアプランを選択可',
    '独立・開業支援あり',
    '海外研修あり',
  ]

  var 給与待遇福利厚生の特徴 = [
    '社会保険完備',
    'ボーナス支給実績あり',
    '寮・社宅あり',
    '住宅手当あり',
    '育児休暇あり',
    '車・バイク出勤可',
    '国内就労ビザ取得支援あり（留学生向け）',
  ]

  var 働き方の特徴 = [
    '年間休日120日以上',
    '完全週休2日制',
    '残業月20時間以内',
    '20時までに退勤可能',
    '有給休暇消化率90%以上',
    '配属店舗の選択可',
    '時短勤務可',
  ]

  function check() {
    window.scrollTo(0, 0);
    setErrorMessage('');

      if (hashTag.tags1.length === 0 || hashTag.tags2.length === 0 || hashTag.tags3.length === 0) {
      setErrorMessage('教育体制・給与・働き方の3項目から、それぞれ1つ以上選択してください。');
    } else {
      save(true);
    }
  }

  const db = getFirestore();

  const [ uploading, setUploading ] = useState(false);

  const buildPayload = (isCompleted: boolean) => ({
    ...hashTag,
    isCompleted,
    time: new Date(),
  });

  async function save(isCompleted: boolean) {
    setUploading(true);

    try {
      const payload = buildPayload(isCompleted);

      await writeJobPostingBothStores(db, companyId, year, {
        hashTag: payload,
      });

      setChangeData(false);
    } catch (error) {
      console.error("🔥 保存に失敗:", error);
      setUploading(false);
    } finally {
      setUploading(false);
      setBanner(true);
      setTimeout(() => setBanner(false), 1500);
    }
  }

  return (
    <>
    {errorMessage !== '' ? <ErrorMessage message={errorMessage} /> : <></> }
    {banner && <div className={Styles.banner}>保存しました。</div>}

    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.title_edit}>
      <h4>ハッシュタグ</h4>
      <div className={Styles.title_edit_btn}>
        <button className={Styles.save_box_now} onClick={() => save(false)}>一時保存</button>
        <button className={Styles.save_box_save} onClick={() => check()}>保存</button>
      </div>
    </div>

    <div className={Styles.test_box}>

      <h5 className={Styles.title}>教育体制の特徴</h5>
      <div className={Styles.numberTag}>
        {教育体制の特徴.map((data, index) =>
          <div key={index}>
            <input type="checkbox"
              checked={hashTag.tags1.indexOf(data) !== -1}
              onChange={(e) => {
                if (e.target.checked) {
                  setHashTag(prev => ({...prev, tags1: [...prev.tags1, data]}))
                  setChangeData(true);
                } else {
                  setHashTag(prev => ({...prev, tags1: prev.tags1.filter(v => v !== data)}))}
                  setChangeData(true);
                }} />
            <p>{data}</p>
          </div>
        )}
      </div>

    </div>


    <div className={Styles.test_box}>

      <h5 className={Styles.title}>給与・待遇・福利厚生の特徴</h5>
      <div className={Styles.numberTag}>
        {給与待遇福利厚生の特徴.map((data, index) =>
          <div key={index}>
            <input type="checkbox"
              checked={hashTag.tags2.indexOf(data) !== -1}
              onChange={(e) => {
              if (e.target.checked) {
                setHashTag(prev => ({...prev, tags2: [...prev.tags2, data]}))
                setChangeData(true);
              } else {
                setHashTag(prev => ({...prev, tags2: prev.tags2.filter(v => v !== data)}))}
                setChangeData(true);
              }} />
            <p>{data}</p>
          </div>
        )}
      </div>

    </div>

    <div className={Styles.test_box}>

      <h5 className={Styles.title}>働き方の特徴</h5>
      <div className={Styles.numberTag}>
        {働き方の特徴.map((data, index) =>
          <div key={index}>
            <input type="checkbox"
              checked={hashTag.tags3.indexOf(data) !== -1}
              onChange={(e) => {
              if (e.target.checked) {
                setHashTag(prev => ({...prev, tags3: [...prev.tags3, data]}))
                setChangeData(true);
              } else {
                setHashTag(prev => ({...prev, tags3: prev.tags3.filter(v => v !== data)}))}
                setChangeData(true);
              }} />
            <p>{data}</p>
          </div>
        )}
      </div>

    </div>
    </>
  );
}

export default RecruitHashTag;
